function getIsApplicantFormDirtyFromOpen() {
  return true
}

export function getIsApplicantFormDirty(isDirtyFromOpen) {
  return isDirtyFromOpen ? getIsApplicantFormDirtyFromOpen : undefined
}
